import { Workflow } from "../../../../../../types"

type Props = {
  info: Workflow
}

const IsDefaultCell = ({ info }: Props) => {
  const { is_default } = info
  return (
    <td className="whitespace-nowrap py-4 pl-2 pr-3 cursor-pointer text-right md:text-left">
      <div className="italic">{is_default ? "Default" : ""}</div>
    </td>
  )
}

export default IsDefaultCell
